// extracted by mini-css-extract-plugin
module.exports = {"pageTopContent":"Teacher3dDisplay_pageTopContent__1owFB"};